import { render, staticRenderFns } from "./EachCountry.vue?vue&type=template&id=70d838f9&"
import script from "./EachCountry.vue?vue&type=script&lang=js&"
export * from "./EachCountry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports